import { render, staticRenderFns } from "./JacRegionBoardMembersEdit.vue?vue&type=template&id=a282df58"
import script from "./JacRegionBoardMembersEdit.vue?vue&type=script&lang=js"
export * from "./JacRegionBoardMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./JacRegionBoardMembersEdit.vue?vue&type=style&index=0&id=a282df58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports